import { render, staticRenderFns } from "./ArMain.vue?vue&type=template&id=a785b136"
import script from "./ArMain.vue?vue&type=script&lang=js"
export * from "./ArMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports